export default __webpack_public_path__ + "static/media/whatsapp.43e81a53.png";